import { useState, useEffect } from 'react';
import { apiClient } from '../../api_actions';
import { orbitalSpinner } from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

const baseChartSeries = [
    {
        type: 'bar',
        xKey: 'name',
        yKey: 'streaming_time',
        yName: 'Total Streaming Hours',
        itemStyler: (params) => ({
            fill: params.datum.isTop ? '#388E3C' : '#B71C1C',
        }),
    }
];

// Separate data transformation
const transformUserStatsForChart = (users) => {
    const sorted = users
        .map(user => {
            const totalTime = user.ovms_log_summary.total_time || 0;
            return {
                name: `${user.first_name} ${user.last_name}`,
                streaming_time: Math.round(totalTime / 3600 * 10) / 10 // Convert seconds to hours
            };
        })
        .sort((a, b) => b.streaming_time - a.streaming_time);

    return sorted.map((item, index) => ({
        ...item,
        isTop: index < 5
    }));
};

// Separate API call
const fetchOVMSUsageData = async (startAndEndUnixDatesParams = '') => {
    try {
        const res = await apiClient.post(`read/ovmslogs?order=balanced&${startAndEndUnixDatesParams()}`);
        if (res && res.data) {
            return transformUserStatsForChart(res.data);
        }
        return [];
    } catch (error) {
        console.error('Failed to load data:', error);
        return [];
    }
};

// Factory function - simplified
const createOVMSUsageConfig = (series = [], data = []) => ({
    title: {
        text: 'Video Streaming Time by User',
    },
    subtitle: { text: 'Top and bottom 5 users by streaming time' },
    series: series,
    data: data,
    overlays: {
        loading: {
            renderer: orbitalSpinner,
        },
    },
    axes: {
        x: {
            type: 'category',
            label: { 
                fontSize: 12,
                rotation: 45,        // Fixed rotation, not auto
                minSpacing: 0,       // Force all labels
             },
        },
    }
});

export const OVMSUsageChartLogic = (startAndEndUnixDatesParams = '') => {
    const [ovmsUsageConfig, setOvmsUsageConfig] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const data = await fetchOVMSUsageData(startAndEndUnixDatesParams);
            setOvmsUsageConfig(createOVMSUsageConfig(baseChartSeries, data));
            setLoading(false);
        };

        loadData();
    }, [startAndEndUnixDatesParams]);

    return {
        chartConfig: ovmsUsageConfig,
        loading,
    };
};
